import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NouisliderModule } from "ng2-nouislider";
import { TagInputModule } from "ngx-chips";
import { MaterialModule, AppModule } from "../app.module";
import { ComponentsModule } from "../shared/components/components.module";
import { SharedModule } from "../shared/shared.module";

import { ModulosRoutes } from "./modulos.routing";

import { VendorsComponent } from "./vendors/vendors.component";
import { ListvendorsComponent } from "./vendors/listvendors/listvendors.component";
import { VendorComponent } from "./vendors/vendor/vendor.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { BuscadorComponent } from "./price-history/buscador/buscador.component";

import { TablesModule } from "../tables/tables.module";
import { InventoryComponent } from "./inventory/inventory.component";
import { CrudInventoryComponent } from "./inventory/crud-inventory/crud-inventory.component";
import { BulkContainerInventoryComponent } from "./inventory/bulk-container-inventory/bulk-container-inventory.component";
import { BulkVirtualContainerInventoryComponent } from "./inventory/bulk-virtual-container-inventory/bulk-virtual-container-inventory.component";
import { PriceHistoryComponent } from "./price-history/price-history.component";
import { CentralizedfilesComponent } from "./centralizedfiles/centralizedfiles.component";
import { VisitorlinkComponent } from "./visitorlink/visitorlink.component";
import { ErasuremethodsComponent } from "./erasuremethods/erasuremethods.component";
import { ContainerstypeComponent } from "./containerstype/containerstype.component";
import { CompanytypeComponent } from "./companytype/companytype.component";
import { InventoryHistoryComponent } from "./inventory-history/inventory-history.component";
import { attributeMultipleItemsComponent } from "../shared/components/attribute-multiple-items/attribute-multiple-items.component";
import { ConfigptoComponent } from "./configpto/configpto.component";
import { YearlyweightgoalComponent } from "./yearlyweightgoal/yearlyweightgoal.component";
import { DetailComponent } from "./inventory/detail/detail.component";
import { InventoryAttributesComponent } from "./inventory/inventory-attributes/inventory-attributes.component";
import { RemoveHardDrivesComponent } from "./inventory/remove-hard-drives/remove-hard-drives.component";
import { VisibilitytablesComponent } from "./visibilitytables/visibilitytables.component";
import { BackgroundprocessComponent } from "./backgroundprocess/backgroundprocess.component";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgApexchartsModule } from "ng-apexcharts";
import { LoadingComponent } from "../shared/components/loading/loading.component";
import { CurrencyComponent } from './currency/currency.component';
@NgModule({
  declarations: [
    VendorsComponent,
    ListvendorsComponent,
    VendorComponent,
    InventoryComponent,
    CrudInventoryComponent,
    PriceHistoryComponent,
    CentralizedfilesComponent,
    BuscadorComponent,
    BulkContainerInventoryComponent,
    BulkVirtualContainerInventoryComponent,
    VisitorlinkComponent,
    ErasuremethodsComponent,
    ContainerstypeComponent,
    CompanytypeComponent,
    InventoryHistoryComponent,
    ConfigptoComponent,
    YearlyweightgoalComponent,
    DetailComponent,
    InventoryAttributesComponent,
    RemoveHardDrivesComponent,
    VisibilitytablesComponent,
    BackgroundprocessComponent,
    CurrencyComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ModulosRoutes),
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule,
    TablesModule,
    CKEditorModule,
    NgxSkeletonLoaderModule,
    NgApexchartsModule
  ],
  entryComponents: [
    VendorComponent,
    BuscadorComponent,
    CrudInventoryComponent,
    BulkContainerInventoryComponent,
    BulkVirtualContainerInventoryComponent,
    attributeMultipleItemsComponent,
    LoadingComponent
  ],
  exports: [
    CrudInventoryComponent,
    VendorComponent,
    BulkContainerInventoryComponent,
    BulkVirtualContainerInventoryComponent,
    attributeMultipleItemsComponent,
    ConfigptoComponent,
    YearlyweightgoalComponent,
    VisitorlinkComponent,
    ErasuremethodsComponent,
    ContainerstypeComponent,
    CompanytypeComponent,
    CurrencyComponent,
    InventoryAttributesComponent
  ],
})
export class ModulosModule {}
